// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { getLang } from 'redux-pagan';
import { connect } from 'react-redux';
import cx from 'classnames';

import AnchorList from '../../components/AnchorList/AnchorList';
import OMTitle from '../../components/OMComponents/OMTitle/OMTitle';
// Styles
import * as styles from '../PrivacyPolicyPage/PrivacyPolicyPage.scss';
import * as helpStyles from './HelpPage.scss';
// Helpers
import questionsData from './questions.json';

import { shareUrl } from '../../constants';
import multiLanguageTags from '../../helpers/multiLanguageHeadTags';
import withPageWrapper from '../../containers/PageContainer/PageContainer';

class HelpList extends AnchorList {
  localRequire = __CLIENT__ && ({
    en: require.context('../../translations/help/en/'),
    ru: require.context('../../translations/help/ru/'),
    he: require.context('../../translations/help/he/')
  });
}

class HelpPage extends Component {
  handleOpen = (idx) => {
    const containerClasses = this[`question-${idx}`].classList;
    if (containerClasses.contains('opened')) {
      containerClasses.remove('opened');
      setTimeout(() => containerClasses.remove('transition'), 200);
    } else {
      containerClasses.add('opened');
      containerClasses.add('transition');
    }
  };

  renderHelmet = () => {
    const { route, locale } = this.props;
    const multiLanguage = multiLanguageTags(route, locale);
    return (
      <Helmet
        titleTemplate={this.props.staticTranslates('title', 'titleTemplate')()}
        title={this.props.staticTranslates('helmet', 'helpTitle')()}
        meta={[
          { property: 'og:url', content: `${shareUrl}${route}` },
          { property: 'og:title', content: `${this.props.staticTranslates('helmet', 'helpTitle')} | \u202BOnMap` },
          { property: 'og:description', content: this.props.staticTranslates('helmet', 'helpDescription') },
          { property: 'x:title', content: `${this.props.staticTranslates('helmet', 'helpTitle')} | \u202BOnMap` },
          { property: 'x:description', content: this.props.staticTranslates('helmet', 'helpDescription') },
          { property: 'x:image:alt', content: this.props.staticTranslates('footer', 'help') },
          { name: 'description', content: this.props.staticTranslates('helmet', 'helpDescription') }
        ]}
        link={[
          ...multiLanguage,
          { rel: 'canonical', href: `${shareUrl}${route}` }
        ]}
      />
    );
  };

  render() {
    // const { locale } = this.props;
    const locale = 'he';

    return (
      <div className={cx(styles.main_block, helpStyles.page, { [helpStyles.mobile]: this.props.isMobile }, 'rtl')}>
        <div className={styles.content}>
          { this.renderHelmet() }
          <div style={{ marginTop: '95px' }}>

            { (!this.props.isMobile && !this.props.isNative) && (
              <OMTitle className="pageTitle" title={this.props.staticTranslates('footer', 'help')} />
            ) }

            <HelpList dataList={questionsData} locale={locale} listComponentClassName={helpStyles.accordion} />
          </div>
        </div>
      </div>
    );
  }
}

HelpPage.propTypes = {
  staticTranslates: PropTypes.func.isRequired,
  route: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  locale: PropTypes.string,
  isNative: PropTypes.bool
};

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'terms'),
  locale: state.lang.locale,
  staticTranslates: getLang(state.lang, 'static')
});

export default connect(mapStateToProps)(
  withPageWrapper(HelpPage)
);
